import React from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";

import Container from "../../components/Container";
import { Footer } from "./components";
import {
  HelpIconInterface,
  MicrocopyResource,
} from "../../utilities/contentful";
import { QuoteRequest } from "../../components/quote/QuoteRequestData";
import { FullQuoteResult } from "../../components/quote/QuoteData.interface";
import Logobar from "./components/Topbar/Logobar";
import { Toolbar } from "@mui/material";
import { PAGE_GUTTER } from "../../utilities/layout";

interface Props {
  children: React.ReactNode;
  quoteMicrocopy: MicrocopyResource[];
  restoredQuote: QuoteRequest | null;
  setQuoteData: React.Dispatch<React.SetStateAction<FullQuoteResult | null>>;
  helpIcons: HelpIconInterface[];
  brand: ContentfulAgent;
  partner: ContentfulPartner | null;
}

const Fixed = ({ children, brand, partner }: Props): JSX.Element => {
  const theme = useTheme();

  const topbarHeight = "98px";

  return (
    <Box>
      <AppBar
        position={"fixed"}
        sx={{ backgroundColor: theme.palette.background.paper }}
        elevation={0}
      >
        <Toolbar
          disableGutters={true}
          sx={{ paddingX: PAGE_GUTTER, height: topbarHeight }}
        >
          <Logobar brand={brand} partner={partner} />
        </Toolbar>
      </AppBar>
      <main>
        <Box
          display="flex"
          flex="1 1 auto"
          overflow="hidden"
          paddingTop={topbarHeight}
          paddingBottom="48px"
        >
          <Box display="flex" flex="1 1 auto" overflow="hidden">
            <Box flex="1 1 auto" height="100%" overflow="auto">
              {children}

              <Container
                disableGutters={true}
                sx={{
                  paddingX: PAGE_GUTTER,
                  paddingY: 0,
                  marginTop: "18px",
                }}
              >
                <Footer />
              </Container>
            </Box>
          </Box>
        </Box>
      </main>
    </Box>
  );
};

export default Fixed;
